<div (click)="dialogRef.close()" *ngIf="loadedMedia as media; else injectedMedia">
    <ng-container *ngIf="media?.isProcessing()">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <mat-icon class="ai-icon">smart_toy</mat-icon>
            <span i18n>Processing image...</span>
        </div>
    </ng-container>
    <ng-container *ngIf="!media?.isProcessing()">
        <app-image-view
            [media_id]="media"
            [ignoreThumbnail]="true"
            [showImgModalOnClick]="false"
            [proportional]="false"
        >
        </app-image-view>
        <div *ngIf="media.id" class="img-info" fxLayout="row" fxLayoutAlign="space-between center">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <mat-icon
                    i18n-matTooltip="@@addToFavorite"
                    (click)="$event.stopPropagation(); this.favorite = !this.favorite; updateFavorite()"
                    [ngStyle]="{ color: '#bfd8d0' }"
                    class="grey favorite-button"
                    matTooltip="Add to favorite"
                    >{{ favorite ? 'favorite' : 'favorite_border' }}</mat-icon
                >
                <button
                    (click)="$event.stopPropagation(); tooltip.toggle()"
                    (mouseenter)="tooltip.show()"
                    [ngStyle]="{ color: '#bfd8d0' }"
                    class="info-button"
                    #tooltip="matTooltip"
                    mat-icon-button
                    matTooltipClass="info-tooltip"
                    [matTooltip]="tooltipInfo"
                >
                    <mat-icon class="material-icons-outlined">info</mat-icon>
                </button>
                <ng-container *ngIf="authUser$ | async as user">
                    <mat-icon
                        i18n-matTooltip="@@edit"
                        (click)="$event.stopPropagation(); edit()"
                        [ngStyle]="{ color: '#bfd8d0' }"
                        class="grey favorite-button"
                        [ngClass]="{ disabled: user.id != media.author_id && !user.isMasterAdmin() }"
                        matTooltip="Edit"
                        >edit</mat-icon
                    >
                </ng-container>
            </div>

            <mat-button-toggle-group
                *ngIf="authUser$ | async as user"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="10px"
                class="mode-toggle"
                [value]="imgAccess.value"
            >
                <mat-button-toggle
                    [disabled]="!user.canEditMedia(media)"
                    value="private"
                    matTooltip="Private"
                    i18n-matTooltip="@@private"
                    (click)="$event.stopPropagation(); imgAccess.setValue('private')"
                >
                    <span class="btn-toggle-text">Private</span>
                </mat-button-toggle>
                <mat-button-toggle
                    [disabled]="!user.canEditMedia(media)"
                    value="academy"
                    matTooltip="Academy"
                    i18n-matTooltip="@@academy"
                    (click)="$event.stopPropagation(); imgAccess.setValue('academy')"
                >
                    <span class="btn-toggle-text">Academy</span>
                </mat-button-toggle>
                <mat-button-toggle
                    [disabled]="!user.canEditMedia(media)"
                    value="public"
                    matTooltip="Public"
                    i18n-matTooltip="@@public"
                    (click)="$event.stopPropagation(); imgAccess.setValue('public')"
                >
                    <span class="btn-toggle-text">Public</span>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </ng-container>
</div>
<ng-template #injectedMedia>
    <app-image-view [media_id]="media" [ignoreThumbnail]="true" [showImgModalOnClick]="false" [proportional]="false">
    </app-image-view>
</ng-template>
<ng-template #loading>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <app-kd-logo-loading></app-kd-logo-loading>
    </div>
</ng-template>
